import { Button } from "primereact/button";
import React, { Component, Fragment } from "react";
import CenterElement from "../../activity/activityComponent/CenterElement";
import DropItemUI from "../../ddTxtImg/ui/DropItemUI";
import CompareItemModel from "../model/CompareItemModel";
import CompareKeyModel from "../model/CompareKeyModel";
import CompareDropItemUI from "./CompareDropItemUI";
// import CompareDropItemUI from "./CompareDropItemUI";
import DropItem from '../../ddTxtImg/model/DropItem'
import { Dialog } from 'primereact/dialog';

class CompareDropItemContainerUI extends Component {
  // state = {
  //   compareItemList: [],
  //   compareKeyList: [],
  //   // dragList:[]
  // };
  render() {
    let { activity, quizViewer } = this.props;
    let { compareContainerModel } = activity
    //let {selectedStyle} = compareContainerModel
    let compareItemList = compareContainerModel.compareItemList;
    let compareKeyList = compareContainerModel.compareKeyList;
    let dropItemList = compareContainerModel.dropItemList;
    //window.projectPlugin.onUiUpdate(selectedStyle)

    //let uiStyle= selectedStyle //JSON.parse(JSON.stringify(selectedStyle))
    return (
      <Fragment>

        <table className="table" >
          <thead className="">
            <tr>
              <th scope="col"
              //  className={uiStyle[0].class} style={uiStyle[0].style}
              ></th>
              {compareItemList.map((item, index) => {
                return (
                  <th
                    // className={uiStyle[0].class} style={uiStyle[0].style}
                    key={index}
                    scope="col"
                  >
                    <div className="p-grid">
                      <div className="p-col-12">
                        <div>{item.compareItemName}</div>
                      </div>
                    </div>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {compareKeyList.map((item, index) => {
              return (
                <tr scope="row" key={index}>
                  <td>
                    <div className="p-grid">
                      <div className="p-col-12" key={index}>
                        <b> {item.compareKeyName}</b> </div>
                    </div>
                  </td>

                  {dropItemList[index].map((dropitem, index1) => {
                    return (
                      <td key={index1}
                      // className={uiStyle[0].class} style={uiStyle[0].style}
                      >
                        <CompareDropItemUI
                          activity={activity}
                          dropItem={dropitem}
                          quizViewer={quizViewer}
                        />

                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>


      </Fragment>
    );
  }

}
export default CompareDropItemContainerUI;
